import { ConfluenceWorkspaceAri } from '@atlassian/ari/confluence';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export function useWorkspaceARI(): string | undefined {
	const { cloudId, activationId } = useSessionData();

	if (!fg('post-office_enable_routing_workspace_id_prop') || !cloudId || !activationId) {
		return undefined;
	}

	return ConfluenceWorkspaceAri.create({ siteId: cloudId, activationId }).toString();
}
